import { Form, Select } from 'antd';
import { messages, placeHolders } from '../../../../../../constants';
import { CustomSelect } from '../../../../../uiComponents/CustomSelect';

export const PurchasedProductSelect = ({
  purchasedProducts,
  appointmentById,
  remainingSessions,
  onPurchasedProductChange,
}) => {
  return (
    <>
      <Form.Item
        label="Tratamientos"
        name="purchasedProductId"
        rules={[{ required: true, message: messages.required('Tratamiento') }]}
      >
        <CustomSelect
          allowClear
          placeholder={placeHolders.purchasedProducts}
          onChange={onPurchasedProductChange}
          options={purchasedProducts
            ?.filter(
              ({ currentSession, sessions, id }) =>
                currentSession < sessions ||
                id === appointmentById?.purchasedProduct?.id
            )
            .map(({ id, treatment, currentSession, sessions }) => ({
              value: id,
              label: `${currentSession}/${sessions} - ${treatment?.name}`,
              sessions,
              currentSession,
            }))}
        />
      </Form.Item>

      <Form.Item
        name="sessions"
        label="Sesiones"
        rules={[{ required: true, message: messages.required('Sesiones') }]}
      >
        <Select allowClear options={remainingSessions} />
      </Form.Item>
    </>
  );
};
